import { Button } from '@repo/studio-design-system-ui-button'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import { useAidaPipStore } from '../../stores/picture-in-picture-store'

export function AidaPictureInPictureShell({
  container,
  dragging,
}: {
  container: HTMLElement
  dragging: boolean
}) {
  return createPortal(<AidaPictureInPictureFrame dragging={dragging} />, container)
}

function AidaPictureInPictureFrame({ dragging }: { dragging: boolean }) {
  const { t } = useTranslation('components')

  return (
    <div className="relative flex h-full min-h-0 flex-col overflow-hidden overscroll-none bg-theme_semantic_surface_primary-background-elevated text-theme_semantic_surface_ui_foreground-color-strong">
      <header className="flex shrink-0 touch-none items-center justify-between gap-2 border-b border-theme_semantic_surface_border_color-subtle px-3 py-2">
        <p className="studio-typography-14">{t('studio.components.aida.title')}</p>
        <Button
          size="xs"
          variant="ghost"
          onClick={() => {
            useAidaPipStore.getState().pipWindow?.close()
          }}
        >
          {t('studio.components.aida.bring_back')}
        </Button>
      </header>
      <div
        ref={node => {
          const current = useAidaPipStore.getState().chatSlot
          if (!node && current?.isConnected) {
            return
          }
          if (current !== node) {
            useAidaPipStore.setState({ chatSlot: node })
          }
        }}
        className="min-h-0 flex-1 overflow-hidden overscroll-none"
      />
      <p className="shrink-0 touch-none px-3 py-2 studio-typography-12 text-theme_semantic_surface_ui_foreground-color-subtle">
        {t('studio.components.aida.pip_rights')}
      </p>
      {dragging ? (
        <div className="pointer-events-none absolute inset-3 flex items-center justify-center rounded-2 border border-dashed border-theme_semantic_surface_border_color-subtle bg-theme_semantic_surface_primary-background-elevated studio-typography-14">
          {t('studio.components.aida.dropToUse')}
        </div>
      ) : null}
    </div>
  )
}

export function AidaPipAwayNotice() {
  const { t } = useTranslation('components')
  return (
    <div className="flex h-full items-center justify-center p-4 text-center">
      <p className="studio-typography-14 text-theme_semantic_surface_ui_foreground-color-subtle">
        {t('studio.components.aida.pip_away')}
      </p>
    </div>
  )
}
